import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
// import { ShapeOptions , CircleProgressComponent} from 'angular2-progressbar';

import { environment } from '../../../';
import { CookieNames, BasicRoutes, CircleUIOptions, ApiEndpoints } from '../../constant';
import { ReportPartsComponent } from './report-parts.component';
/**
 * import services
 */
import { CookieManagerService , ErrorManagerService, OrderBy, HttpClientService } from '../../../shared/';
import { TranslateService } from '@ngx-translate/core';
import { PaperSet , PaperReport} from '../../model';

@Component({
  selector: 'app-report',
  templateUrl: '../views/report.component.html',
  styleUrls: ['../../../css/report.component.css','../../../css/paper-sets.component.css']
})
export class ReportComponent implements OnInit {

  // @ViewChild(CircleProgressComponent) circleComp: CircleProgressComponent;

  papersUrl:string = BasicRoutes.clientPapers;
  paperSets: Array<PaperSet> = [];
  papersReport: PaperReport;
  paperSetsStatics:any=[];
  totalReport: string;
  realseAt: string;
  public isLogin : boolean ;
  
  
  constructor(private httpClientService: HttpClientService,
    private cookieManagerService: CookieManagerService,
    private ErrorManagerService: ErrorManagerService,
    public toastr: ToastsManager,
    private translateService : TranslateService,
    private router: Router) { }
  
  // private circleOptions: ShapeOptions = {
  //   color: CircleUIOptions.fillColor,
  //   trailColor: CircleUIOptions.trailColor,
  //   trailWidth: CircleUIOptions.trailWidth,
  //   duration: CircleUIOptions.duration,
  //   easing: CircleUIOptions.easing,
  //   strokeWidth: CircleUIOptions.strokeWidth,
  //   from: { color: CircleUIOptions.fillColor, a: 0 },
  //   to: { color: CircleUIOptions.baseColor, a: 1 },
  //   step: function(state: any, circle: any) {
  //     circle.path.setAttribute(CircleUIOptions.theme, CircleUIOptions.fillColor);
  //   }
  // };

  ngOnInit() {
    let token = this.cookieManagerService.getCookie(CookieNames.loginKey, false);
    this.isLogin = token ? true : false;
    if(this.isLogin){
      this.router.navigate(['home/statistics/overall']);
      this.getStaticReportSets();
      this.getPeparSet();
      window.scrollTo(0, 0);
    }
  }

  setAllMakes() {
    let total = this.papersReport['totalReport'];
    this.totalReport =total!==100 ? Math.round(total).toFixed(1)+"%": Math.round(total) +"%";
    // this.circleComp.animate(total /100);
  }

  getStaticReportSets() {
    this.httpClientService.authGet(ApiEndpoints.paperSetReportStaticts , null).subscribe(response => {
        this.papersReport= response;
        this.setAllMakes()
      }, error => {
        // this.ErrorManagerService.setError(error);
      });
  }

  getPeparSet(){
    this.httpClientService.authGet(ApiEndpoints.paperSetReports,  null).subscribe(response => {
      
      response.length > 0 ? response.forEach(paperSet => {
        this.paperSets.push(paperSet);
        if(paperSet.isOnlinePaper){
          let date = new Date(paperSet.resultReleaseAt);
          this.realseAt = date.toLocaleDateString().replace(new RegExp('/', 'g'), '-') + this.translateService.instant('TIME') + date.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
        }
      }) : [];
    
    }, error =>{
        this.ErrorManagerService.setError(error);
    });
  }

  paperSetRouter(paper){
    this.cookieManagerService.setCookie(CookieNames.paperSettitle, paper.title, false, 1);
    this.router.navigate(['home/reports/'+paper._id+'/papers']);
  }


}


// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/report/components/report.component.ts